import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const conversionsAnalysis = createApi({
  baseQuery: fetchBaseQueryCSRF({ baseUrl: CROSS_API_URL }),
  reducerPath: 'api.conversionsAnalysis',
  tagTypes: ['conversionsAnalysis'],
  endpoints: (builder) => ({
    getFilters: builder.query<any, {
      workspaceId: any,
      start_date: string | null,
      end_date: string | null,
      countries: string[],
      devices: string[],
      platforms: string[]
    }>({
      query: ({ workspaceId, start_date, end_date, countries, devices, platforms }) => {
        const url = `/conversionsAnalysis/getFilters`;
        const body = {
          workspaceId,
          start_date,
          end_date,
          countries,
          devices,
          platforms,
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getBankingWidgetSummary: builder.query<any, {
      workspaceId: any,
      start_date: string | null,
      end_date: string | null,
      countries: string[],
      devices: string[],
      platforms: string[],
      conversionType?: string,
      compare_start_date: any,
      compare_end_date: any,
      compare: any,
      timestep: any
    }>({
      query: ({ workspaceId, start_date, end_date, countries, devices, platforms, conversionType, compare_end_date, compare_start_date, compare, timestep }) => {
        const url = `/conversionsAnalysis/getBankingWidgetSummary`;
        const body = {
          workspaceId,
          start_date,
          end_date,
          countries,
          devices,
          platforms,
          compare_end_date,
          compare_start_date,
          conversionType,
          compare, 
          timestep
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getBreakdownChartData: builder.query<any, {
      workspaceId: any,
      start_date: string | null,
      end_date: string | null,
      conversionType: string,
      metric: "Revenue" | "Conversions",
      dimension: "channel" | "country" | "device" | "platform",
      timestep: any,
      devices: any,
      platform: any,
      countries: any
    }>({
      query: ({ workspaceId, start_date, end_date, conversionType, metric, dimension, timestep, countries, platform, devices }) => {
        const url = `/conversionsAnalysis/getBreakdownChartData`;
        const body = {
          workspaceId,
          start_date,
          end_date,
          conversionType,
          metric,
          dimension,
          timestep,
          devices,
          platform,
          countries
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getGridConfig: builder.query<any, {
      workspaceId: any,
      countries: string[],
      platforms: string[]
    }>({
      query: ({ workspaceId, countries, platforms }) => {
        return {
          url: `/conversionsAnalysis/getGridConfig`,
          method: 'POST',
          body: JSON.stringify({ workspaceId, countries, platforms }),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getGridData: builder.query<any, {
      workspaceId: any,
      start_date: string | null,
      end_date: string | null,
      conversionType: string,
      dimension: string,
      timestep: any,
      devices: any,
      countries: any,
      platform: any,
      compare: any,
      compare_start_date: any,
      compare_end_date: any
    }>({
      query: ({ workspaceId, start_date, end_date, conversionType, dimension, timestep, countries, devices, platform, compare, compare_start_date, compare_end_date }) => {
        return {
          url: `/conversionsAnalysis/getGridData`,
          method: 'POST',
          body: JSON.stringify({ workspaceId, start_date, end_date, conversionType, dimension, timestep, countries, devices, platform, compare, compare_start_date, compare_end_date }),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),

  }),
});

export const {
  useGetFiltersQuery,
  useGetBankingWidgetSummaryQuery,
  useGetBreakdownChartDataQuery,
  useGetGridConfigQuery,
  useGetGridDataQuery
} = conversionsAnalysis;

export default conversionsAnalysis;
